var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNavigationArrowForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "icon-navigation-arrow-forward_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-74 -17)",
    filter: "url(#icon-navigation-arrow-forward_svg__a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86 21.09l-1.41 1.41 5.58 5.59H78v2h12.17l-5.58 5.59L86 37.09l8-8z",
    fill: "#2C3032"
  }))));
}

export default __webpack_public_path__ + "1c4161f6294dbb7583c9341ccc32c520.svg";
export { SvgIconNavigationArrowForward as ReactComponent };